import React from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spin } from "antd";

import Discounts from "./components/Discounts";
import MarketingLayout from "./layout";
import Products from "../Products";
import Financing from "pages/Financing";
import Markups from "pages/Markup";

function MarketingRouter() {
  const roles = useSelector((state) => state.auth.data.roles);

  // if (!roles || roles.length === 0) {
  //   return (
  //     <div style={{
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       height: "100vh",
  //     }}>
  //       <Spin />
  //     </div>
  //   );
  // }

  return (
    <Routes>
      <Route path="" element={<MarketingLayout />}>
        <Route path="/affinity-partners" element={<Discounts />} />
        <Route path="/discount-reasons" element={<Discounts />} />
        <Route path="/subsidies" element={<Discounts />} />
        <Route path="/matrix" element={<Discounts />} />
        <Route path="/everyday-low" element={<Discounts />} />
        <Route path="/products" element={<Products />} />
        <Route path="/financing-options" element={<Financing />} />
        <Route path="/markups" element={<Markups />} />
      </Route>
    </Routes>
  );
}

export default MarketingRouter;
